"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _reactRouterDom = require("react-router-dom");

var _Toggler = _interopRequireDefault(require("../Toggler"));

var _DropdownElements = _interopRequireDefault(require("./DropdownElements"));

var FLIGHT_LINK = [{
  title: 'Kathmandu to Lukla',
  url: '/flights '
}, {
  title: 'Ramechhap to Lukla',
  url: '/flights/ramechhap-to-lukla-online-flight-booking'
}, {
  title: 'Pokhara to Jomsom',
  url: '/flights/pokhara-to-jomsom-online-flight-booking'
}];

function FlightsDropdown(_ref) {
  var location = _ref.location,
      homepage = _ref.homepage;
  return _react["default"].createElement(_Toggler["default"], null, function (_ref2) {
    var on = _ref2.on,
        toggle = _ref2.toggle;
    return _react["default"].createElement(_reactstrap.Dropdown, {
      nav: true,
      isOpen: on,
      toggle: toggle
    }, _react["default"].createElement(_reactstrap.DropdownToggle, {
      nav: true,
      caret: true,
      color: "none",
      className: "btn-nav-bar"
    }, _react["default"].createElement("span", null, "Flights"), _react["default"].createElement("div", {
      className: homepage ? 'd-none' : 'd-block d-lg-none mobile-icon'
    }, _react["default"].createElement("img", {
      src: "https://s3.amazonaws.com/honeyguide/assets/icons/flight.svg",
      alt: ""
    }), _react["default"].createElement("p", null, "Flights"))), _react["default"].createElement(_reactstrap.DropdownMenu, {
      className: "setting-dp"
    }, FLIGHT_LINK.map(function (_ref3) {
      var title = _ref3.title,
          url = _ref3.url;
      return _react["default"].createElement(_DropdownElements["default"], {
        key: title,
        link: url,
        title: title,
        isElementVisible: true,
        location: location
      });
    })));
  });
}

var _default = (0, _reactRouterDom.withRouter)(FlightsDropdown);

exports["default"] = _default;